(function() {
  // Only run on water delivery subscription product page
  if (window.location.pathname.indexOf('water-delivery-subscription') === -1) return;

  var DEPOSIT_VARIANT_ID = 50304996278492;
  var SUBSCRIPTION_VARIANT_ID = 50308984242396;
  var SELLING_PLAN_ID = 33418510556;

  function attachDepositLogic() {
    var btn = document.getElementById('add-to-cart');
    if (!btn || btn.getAttribute('data-deposit-attached')) return;

    btn.setAttribute('data-deposit-attached', 'true');

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Adding...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: SUBSCRIPTION_VARIANT_ID,
              quantity: 1,
              selling_plan: SELLING_PLAN_ID
            },
            {
              id: DEPOSIT_VARIANT_ID,
              quantity: 1
            }
          ]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status === 422 || data.description) {
          throw new Error(data.description || 'Could not add to cart.');
        }
        window.location.href = '/cart';
      })
      .catch(function(err) {
        alert('Something went wrong: ' + err.message);
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      });
    }, true);
  }

  // Try immediately on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    attachDepositLogic();

    // Also observe DOM for dynamically added buttons (Hulk app renders late)
    var observer = new MutationObserver(function() {
      attachDepositLogic();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Stop observing after 5 seconds to save memory
    setTimeout(function() { observer.disconnect(); }, 5000);
  });
})();